// src/features/procedures/services/procedures.js
import { apiClient } from '../../../services/api/client';

export const proceduresAPI = {
  // List procedures for department
  listProcedures: (includeInactive = false) => 
    apiClient.get('/api/v1/procedures/', {
      params: { include_inactive: includeInactive }
    }),
  
  // Get procedure details by ID
  getProcedureById: (procedureId) => 
    apiClient.get(`/api/v1/procedures/${procedureId}`),
  
  // Create procedure
  createProcedure: (data) => 
    apiClient.post('/api/v1/procedures/', data),
  
  // Update procedure
  updateProcedure: (procedureId, data) => 
    apiClient.put(`/api/v1/procedures/${procedureId}`, data),
  
  // Delete procedure
  deleteProcedure: (procedureId) => 
    apiClient.delete(`/api/v1/procedures/${procedureId}`),
  
  // Add step to procedure
  addProcedureStep: (procedureId, stepData) => 
    apiClient.post(`/api/v1/procedures/${procedureId}/steps`, stepData),
  
  // Link procedure to task
  linkProcedureToTask: (taskId, data) => 
    apiClient.post(`/api/v1/procedures/tasks/${taskId}/link`, data),
  
  // Start procedure execution
  startProcedureExecution: (taskId, data) => 
    apiClient.post(`/api/v1/procedures/tasks/${taskId}/execute`, data),
  
  // Get procedure execution
  getProcedureExecution: (executionId) => 
    apiClient.get(`/api/v1/procedures/executions/${executionId}`),
  
  // Submit step response
  submitStepResponse: (executionId, responseData) => 
    apiClient.post(`/api/v1/procedures/executions/${executionId}/responses`, responseData),
  
  // Complete procedure execution
  completeProcedureExecution: (executionId) => 
    apiClient.post(`/api/v1/procedures/executions/${executionId}/complete`),
  
  // Cancel procedure execution
  cancelProcedureExecution: (executionId) => 
    apiClient.post(`/api/v1/procedures/executions/${executionId}/cancel`),
};